import { Component, OnInit } from '@angular/core';
import SwiperCore, {
  Autoplay,
  Keyboard,
  Pagination,
  Scrollbar,
  Zoom,
  SwiperOptions,
} from 'swiper';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MetaService } from 'src/app/services/meta.service';
import { LanguageService } from 'src/app/services/language.service';
SwiperCore.use([Autoplay, Keyboard, Pagination, Scrollbar, Zoom]);
@Component({
  standalone: false,
  selector: 'app-products-details',
  templateUrl: './products-details.component.html',
  styleUrls: ['./products-details.component.scss'],
})
export class ProductsDetailsComponent implements OnInit {
  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: { clickable: true },
  };
  prodId: any;
  rateArr: any = [];
  prodName: any = '';
  images: any = [];
  description: any = '';
  stock: any = '';
  prodPrice: any;
  reviews: any = [];
  prodObj: any;
  count = 1;
  activeRate = false;
  textArea: any;
  token: any;
  clientID: any;
  mainImages_arr: any = [];
  screenShootImage: any = [];
  videos_arr: any = [];
  isPortrait = false;
  variants: any[] = [];
  selectedVariant: any = null;
  displayPrice: any;
  inWishlist = false;
  discount = 0;
  lang: 'en' | 'ar' = 'en';
  constructor(
    private route: ActivatedRoute,
    private routing: Router,
    private _sanitizer: DomSanitizer,
    private rest: RestService,
    private metaService: MetaService,
    private langService: LanguageService
  ) {}

  ngOnInit() {
    this.token = localStorage.getItem('token');
    this.clientID = localStorage.getItem('clientID');
    this.prodId = this.route.snapshot.paramMap.get('id');
    this.lang = this.langService.current;
    this.langService.lang$.subscribe(lang => {
      this.lang = lang;
      if (this.prodObj) this.applyLang();
    });
    this.getData();

    // Update meta tags dynamically
    this.metaService.updateMetaTags(
      this.prodName,
      this.description,
      this.mainImages_arr[0],
      window.location.href
    );
  }

  private applyLang(): void {
    const ar = this.lang === 'ar';
    this.prodName = (ar && this.prodObj.name_ar) ? this.prodObj.name_ar : this.prodObj.name;
    const rawDesc = (ar && this.prodObj.description_ar) ? this.prodObj.description_ar : (this.prodObj.description || '');
    if (rawDesc.includes('\u2022')) {
      this.description = rawDesc.split('\u2022');
    } else {
      this.description = rawDesc.split('.');
    }
  }

  getData() {
    this.rest.prodDetails(this.prodId).subscribe((res: any) => {
      this.prodObj = res;
      this.stock = res.quantity;
      this.prodPrice = res.price;
      this.discount = res.discount || 0;
      this.displayPrice = this.discount > 0
        ? Math.round(this.prodPrice * (100 - this.discount) / 100)
        : this.prodPrice;
      this.applyLang();

      if (res.images.length == 0) {
        res.images.push({
          image: 'assets/images/rk.jpeg',
        });
      } else {
        res.images.forEach((element: any) => {
          if (element.image_type == null) {
            element.image_url = `${environment.apiUrl}/images/?id=${element.image_url}`;
            this.mainImages_arr.push(element);
          } else {
            if (element.image_type.includes('main')) {
              element.image_url = `${environment.apiUrl}/images/?id=${element.image_url}`;
              this.mainImages_arr.push(element);
            }
            if (element.image_type.includes('screenshot')) {
              element.image_url = `${environment.apiUrl}/images/?id=${element.image_url}`;
              this.screenShootImage.push(element);
            }
            if (element.image_type.includes('video')) {
              element.image_url = `${environment.apiUrl}/images/?id=${element.image_url}`;
              this.videos_arr.push(element);
            }
          }
        });
      }
      this.images = res.images;
      this.rateArr = new Array(res.rating);
      res.reviews.forEach((element: any) => {
        element.arr = new Array(element.rating);
      });
      this.reviews = res.reviews;
    });

    this.rest.getProductVariants(this.prodId).subscribe((res: any) => {
      this.variants = res || [];
    });

    if (this.token && this.clientID) {
      this.rest.getWishlist(this.clientID, this.token).subscribe((res: any) => {
        const list = res || [];
        this.inWishlist = list.some((w: any) => w.product_id == this.prodId);
      });
    }
  }

  selectVariant(variant: any): void {
    this.selectedVariant = variant;
    const base = this.discount > 0
      ? Math.round(this.prodPrice * (100 - this.discount) / 100)
      : this.prodPrice;
    this.displayPrice = base + variant.price_modifier;
  }

  toggleWishlist(): void {
    if (!this.token) {
      this.routing.navigateByUrl('/login');
      return;
    }
    if (this.inWishlist) {
      this.rest.removeFromWishlist(this.clientID, this.prodId, this.token).subscribe(() => {
        this.inWishlist = false;
        this.rest.successToast('toast.wishlist_removed');
        this.updateWishlistBadge();
      });
    } else {
      const obj = { client_id: parseInt(this.clientID), product_id: parseInt(this.prodId) };
      this.rest.addToWishlist(obj, this.token).subscribe(() => {
        this.inWishlist = true;
        this.rest.successToast('toast.wishlist_added');
        this.updateWishlistBadge();
      });
    }
  }

  private updateWishlistBadge(): void {
    this.rest.getWishlist(this.clientID, this.token).subscribe((res: any) => {
      this.rest.sendWishlistCount((res || []).length);
    });
  }
  addToCart() {
    if (localStorage.getItem('token')) {
      let carts: any = localStorage.getItem('cart');
      carts = JSON.parse(carts);
      const effectiveBase = this.discount > 0
        ? Math.round(this.prodPrice * (100 - this.discount) / 100)
        : this.prodPrice;
      const cartItem = {
        ...this.prodObj,
        price: effectiveBase + (this.selectedVariant?.price_modifier || 0),
        count: this.count,
        variant_id: this.selectedVariant?.id || null,
      };

      if (carts) {
        const existingItem = carts.find(
          (cart: any) => cart?.id === cartItem.id && cart?.variant_id === cartItem.variant_id
        );
        if (existingItem) {
          existingItem.count += 1;
        } else {
          carts.push(cartItem);
        }
        localStorage.setItem('cart', JSON.stringify(carts));
        this.rest.successToast('toast.cart_added');
        this.rest.postCART(carts, this.token).subscribe((res: any) => {});
      } else {
        let cart = [cartItem];
        localStorage.setItem('cart', JSON.stringify(cart));
        this.rest.successToast('toast.cart_added');
        this.rest.postCART(cart, this.token).subscribe((res: any) => {});
      }

      this.rest.SendDataCard(true);
    } else {
      this.routing.navigateByUrl('/login');
    }
  }

  onImageLoaded(event: Event): void {
    const img = event.target as HTMLImageElement;
    this.isPortrait = img.naturalHeight > img.naturalWidth;
  }

  plus() {
    this.count = this.count + 1;
  }
  minus() {
    if (this.count > 1) {
      this.count = this.count - 1;
    }
  }

  rateId: string | any;
  goActiveRate(id: any) {
    this.activeRate = !this.activeRate;
    if (id != this.rateId) {
      this.activeRate = true;
    }
    this.rateId = id;
  }

  addReview() {
    let obj = {
      client_id: this.clientID,
      product_id: this.prodId,
      rating: this.rateId,
      review: this.textArea,
    };
    this.rest.addRate(obj, this.token).subscribe((res: any) => {
      this.textArea = '';
      this.rateId = 0;
      this.getData();
    });
  }
}
